import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import Home from '../pages/Home'

export default function HomeRedirect() {
  const { currentUser } = useAuth()

  // If logged in, redirect to boxes, otherwise show home
  if (currentUser) {
    return <Navigate to="/boxes" replace />
  }

  // Show home page for unauthenticated users
  return <Home />
}

